import { render } from "./xlist.vue?vue&type=template&id=0071619a"
import script from "./xlist.vue?vue&type=script&lang=js"
export * from "./xlist.vue?vue&type=script&lang=js"

import "./xlist.vue?vue&type=style&index=0&id=0071619a&lang=css"

import exportComponent from "D:\\aa_Myproject\\98tang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__